import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "results"
}
const _hoisted_2 = { class: "results__text" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Re-take quiz ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FetchingError = _resolveComponent("FetchingError")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Heading2 = _resolveComponent("Heading2")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.fetchingError)
    ? (_openBlock(), _createBlock(_component_FetchingError, { key: 0 }))
    : (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Heading2, { variant: "capitalized" }, {
            default: _withCtx(() => [
              _createTextVNode(" Thanks, " + _toDisplayString(_ctx.formValues.name) + "! ", 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_2, " You answered correctly to " + _toDisplayString(_ctx.quizResults.correct) + " out of " + _toDisplayString(_ctx.quizResults.total) + " questions. ", 1),
          _createVNode(_component_Button, {
            variant: "primary",
            "onButton:onClick": _cache[0] || (_cache[0] = ($event: any) => (this.$emit('onClick')))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
}